export function getCategory(
  birthYear: number,
  competitionYear = 2027
): string {

  const age = competitionYear - birthYear;

  if (age < 9) return "U9";
  if (age < 11) return "U11";
  if (age < 13) return "U13";
  if (age < 15) return "U15";
  if (age < 18) return "U18";
  return "U21+";
}
